// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileFilledSvg from "@ant-design/icons-svg/es/asn/ProfileFilled";
import AntdIcon from '../components/AntdIcon';

var ProfileFilled = function ProfileFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProfileFilledSvg
  }));
};

ProfileFilled.displayName = 'ProfileFilled';
export default React.forwardRef(ProfileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ProfileFilled.js
// module id = 1619
// module chunks = 0